<template>
  <div class="news-list-container newspagination">
    <h1 class="news-list-header  ">Останні новини</h1>
    <div class="news-list">
      <div
        class="news flex-wrap justify-center align-center"
        v-for="newsItem in news"
        :key="newsItem.id"
      >
        <router-link
          :to="getNewsLink(newsItem)"
          class="d-flex"
          style="flex: 0 1 28rem"
        >
          <display-image
            :contain="true"
            class="news-image"
            :imageId="newsItem.imageId"
          />

        </router-link>
        <div class="news-text">
          <h2>
            <router-link :to="getNewsLink(newsItem)">{{
              newsItem.title
            }}</router-link>
          </h2>
          <div class="news-date">
            {{
              new Date(newsItem.date).toLocaleDateString('uk-UA', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })
            }}
          </div>
          <div class="news-short-description">
            {{ newsItem.shortDescription }}
          </div>
        </div>
      </div>
    </div>
    <pagination
      v-model="currentPage"
      :totalPageCount="totalPageCount"
    />
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import axios from '../../../services/service.data-access'
import DisplayImage from '../../_shared/DisplayImage.vue'
import Pagination from '../../_shared/Pagination.vue'

export default {
  name: 'NewsList',
  components: {
    DisplayImage,
    Pagination
  },
  props: {
    model: {
      default: () => ({})
    }
  },
  data: () => ({
    news: [],
    overlay: false,
    currentPage: 1,
    totalCount: 0,
    totalPageCount: 0,
    filterModel: {
      pageSize: 10,
      pageIndex: 0
    }
  }),
  async created() {
    await this.loadNews(this.filterModel)
  },
  methods: {
    async loadNews(filterModel) {
      try {
        this.overlay = true
        const result = await axios.getAllNews(filterModel)
        this.news = result.data
        this.totalCount = result.totalCount
        this.totalPageCount = result.totalPageCount
      } catch (e) {
      } finally {
        this.overlay = false
      }
    },
    getNewsLink(item) {
      return {
        name: 'subDynamic',
        params: {
          urlKey: this.model.metadata.newsDetailsUrlKey,
          subUrlKey: item.urlKey
        }
      }
    }
  },
  watch: {
    currentPage: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.filterModel.pageIndex = newVal - 1
        this.loadNews(this.filterModel)
      }
    }
  }
}
</script>
<style lang="scss">
.news-list-container {
  font-size: 1.6rem;
  padding: 4rem 0;

  .news-list-header {
    font-size: 3.8rem;
  }
  .news-text {
    flex: 1 1 20rem;
    padding: 1rem 2rem;

    a {
      color: black;
      text-decoration: none;
      font-size: 2rem;
    }

    .news-date {
      color: grey;
      font-size: 1.3rem;
      margin-top: 1rem;
    }

    .news-short-description {
      margin-top: 1rem;
    }
  }

  .first-news {
    display: flex;
    flex: 1 1 auto;
    flex-direction: row;
    margin-bottom: 4rem;

    .fisrt-news-img {
      flex: 0 0 45rem;
      display: flex;
      justify-content: center;
    }
  }

  .news-list {
    display: flex;
    flex-direction: column;

    .news {
      display: flex;
      flex-direction: row;
      margin-top: 4rem;

      .news-image {
        flex: 0 1 28rem;
        display: flex;
        height: 100%;
      }
    }
  }
}
</style>
